import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Input, Modal, Switch, InputNumber, Table, Tabs } from 'antd';
import './SysParamManage.less';
const TabPane = Tabs.TabPane;

class SysParamManage extends PureComponent {
  constructor() {
    super();
    this.state = {
      editRowId: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.inputRef) {
      const input = this.inputRef.refs.input;
      input.focus();
    }
  }
  componentWillMount() {
  }

  render() {
    const { iworkData = [], meetingData = [], intl, dispatch } = this.props;
    const { editRowId } = this.state;
    let columns = [
      {
        title: 'Param Key',
        width: '33%',
        key: 'paramKey',
        render: record => {
          return (
            <div style={{ width: '100%', minHeight: '28px', lineHeight: '28px' }} >
              <span>{record.paramKey}</span>
            </div>
          );
        }
      },
      {
        title: 'Param Desc',
        width: '33%',
        key: 'paramDesc',
        render: record => {
          if (record.id + '_paramDesc' == editRowId) {
            return (
              <Input
                className={'input-edit'}
                defaultValue={record.paramDesc}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this.setState({ editRowId: '' });
                  dispatch({ type: 'sysParam/saveParam', payload: record});
                }}
                onChange={e => {
                  iworkData.map(item => {
                    if (item.id == record.id) {
                      item.paramDesc = e.target.value;
                    }
                  });
                  dispatch({ type: 'sysParam/update', payload: { iworkData } });
                }}
              />
            );
          } else {
            return (
              <div
                style={{ width: '100%', minHeight: '28px', lineHeight: '28px' }}
                onClick={() => {
                  this.setState({ editRowId: record.id + '_paramDesc' });
                }}
              >
                <span>{record.paramDesc}</span>
              </div>
            );
          }
        }
      },
      {
        title: 'Param Value',
        width: '34%',
        key: 'paramValue',
        render: record => {
          let this_ = this;
          if (record.id + '_paramValue' == editRowId) {
            return (
              <Input
                className={'input-edit'}
                defaultValue={record.paramValue}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this_.setState({ editRowId: '' });
                  dispatch({ type: 'sysParam/saveParam', payload: record});
                }}
                onChange={e => {
                  iworkData.map(item => {
                    if (item.id == record.id) {
                      item.paramValue = e.target.value;
                    }
                  });
                  dispatch({ type: 'sysParam/update', payload: { iworkData } });
                }}
              />
            );
          } else {
            return (
              <div
                style={{ width: '100%', minHeight: '28px', lineHeight: '28px' }}
                onClick={() => {
                  this.setState({ editRowId: record.id + '_paramValue' });
                }}
              >
                <span>{record.paramValue}</span>
              </div>
            );
          }
        }
      }
    ];


    let mColumns = [
      {
        title: 'DKey',
        width: '33%',
        key: 'dkey',
        render: record => {
          return (
            <div style={{ width: '100%', minHeight: '28px', lineHeight: '28px' }} >
              <span>{record.dkey}</span>
            </div>
          );
        }
      },
      {
        title: 'Remark',
        width: '33%',
        key: 'remark',
        render: record => {
          if (record.id + '_remark' == editRowId) {
            return (
              <Input
                className={'input-edit'}
                defaultValue={record.remark}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this.setState({ editRowId: '' });
                  dispatch({ type: 'sysParam/saveDictionary', payload: record});
                }}
                onChange={e => {
                  meetingData.map(item => {
                    if (item.id == record.id) {
                      item.remark = e.target.value;
                    }
                  });
                  dispatch({ type: 'sysParam/update', payload: { meetingData } });
                }}
              />
            );
          } else {
            return (
              <div
                style={{ width: '100%', minHeight: '28px', lineHeight: '28px' }}
                onClick={() => {
                  this.setState({ editRowId: record.id + '_remark' });
                }}
              >
                <span>{record.remark}</span>
              </div>
            );
          }
        }
      },
      {
        title: 'DValue',
        width: '34%',
        key: 'dvalue',
        render: record => {
          let this_ = this;
          if (record.id + '_dvalue' == editRowId) {
            return (
              <Input
                className={'input-edit'}
                defaultValue={record.dvalue}
                ref={node => (this.inputRef = node)}
                onBlur={() => {
                  this_.setState({ editRowId: '' });
                  dispatch({ type: 'sysParam/saveDictionary', payload: record});
                }}
                onChange={e => {
                  meetingData.map(item => {
                    if (item.id == record.id) {
                      item.dvalue = e.target.value;
                    }
                  });
                  dispatch({ type: 'sysParam/update', payload: { meetingData } });
                }}
              />
            );
          } else {
            return (
              <div
                style={{ width: '100%', minHeight: '28px', lineHeight: '28px' }}
                onClick={() => {
                  this.setState({ editRowId: record.id + '_dvalue' });
                }}
              >
                <span>{record.dvalue}</span>
              </div>
            );
          }
        }
      }
    ];

    return (
      <div className="sys-param-manage">
        <Tabs defaultActiveKey="1">
          <TabPane tab="iwork系统参数配置" key="1">
            <Table
              bordered
              rowKey={record => record.id}
              dataSource={iworkData}
              columns={columns}
              pagination={false}
            />
          </TabPane>
          <TabPane tab="meeting系统参数配置" key="2">
              <Table
                bordered
                rowKey={record => record.id}
                dataSource={meetingData}
                columns={mColumns}
                pagination={false}
              />
          </TabPane>
        </Tabs>

      </div>
    );
  }
}

const mapStateToProps = state => {
  const { sysParam, i18n } = state;
  sysParam.i18n = i18n;
  return { ...sysParam };
};

export default connect(mapStateToProps)(injectIntl(SysParamManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/SysParamManage.js